<template>
  <div class="">
    <!-- <h2 class="title">Gear List</h2> -->
    <div class="gearlist">
      <div class="list" v-for="value in gear" :key="value.id">
        <h3 class="category">{{ value.title }}</h3>
        <div class="item" v-for="item in value.items" :key="item.id">
          <p class="item-type">{{ item.type }}</p>
          <a
            class="item-brand"
            v-if="item.link"
            target="_blank"
            rel="nofollow"
            :href="item.link"
            >{{ item.brand }}</a
          >
          <p class="item-brand" v-else>{{ item.brand }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    gear() {
      return [
        {
          title: 'pc',
          items: [
            {
              type: 'CPU',
              brand: 'Intel i7 3930k',
              link: 'https://amzn.to/2VC5xhK'
            },
            {
              type: 'Graphics Card',
              brand: 'EVGA GTX 680'
            },
            {
              type: 'Memory',
              brand: 'Corsair Vengence DDR3 32GB'
            },
            {
              type: 'Motherboard',
              brand: 'Gigabyte GA-X79-UP4'
            }
          ]
        },
        {
          title: 'accessories',
          items: [
            {
              type: 'Keyboard',
              brand: 'Vortex Poker II'
            },
            {
              type: 'Mouse',
              brand: 'Logitech G9X or G900',
              link: 'https://amzn.to/2E5VlHf' // logitech g900
            },
            {
              type: 'Mousepad',
              brand: 'Steelseries QcK',
              link: 'https://amzn.to/2YFh0jc'
            },
            {
              type: 'Microphone',
              brand: 'AKG P120',
              link: 'https://amzn.to/2YyXIvA'
            },
            {
              type: 'Headphones',
              brand: 'AKG K7XX',
              link: 'https://www.massdrop.com/home?referer=QNMVHV'
            },
            {
              type: 'Audio Interface',
              brand: 'Focusrite Scarlett 2i4',
              link: 'https://amzn.to/2scGAQg'
            },
            {
              type: 'Webcam',
              brand: 'Logitech C920',
              link: 'https://amzn.to/38sDpVm'
            },
            {
              type: 'Speakers',
              brand: 'Mackie MK5 MR2'
            }
          ]
        }
      ];
    }
  },
  props: {
    // value: {
    //   type: Boolean,
    //   required: true
    // }
  },
  data() {
    return {
      isVisible: this.value
    };
  },
  watch: {
    value(val) {
      this.isActive = val;
    }
  },
  methods: {
    show() {
      this.$emit('open');
      this.isActive = true;
    },
    hide() {
      this.$emit('close');
      this.isActive = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.gearlist {
  background-color: rgba(0, 0, 0, 0.76);
  border: 1px solid #c2c2c2;
  box-shadow: 0 9px 9px -6px rgba(0, 0, 0, 0.3);
  max-width: 600px;
  padding: 10px;
  width: 100%;
}

.title {
  color: #fff;
  font-size: 24px;
  margin-bottom: 10px;
  text-align: center;
}

.list {
  padding: 15px;
  position: relative;
}

.category {
  color: #fff;
  font-size: 20px;
  margin-bottom: 20px;
  // margin-top: 20px;
  margin-top: 0;

  text-align: center;
}

.item {
  display: flex;
  justify-content: center;
  position: relative;
  &::after {
    content: '';
    // background-color: #000;
    background-color: #fff;
    position: absolute;
    height: 100%;
    left: 0;
    margin-left: auto;
    margin-right: auto;
    right: 0;
    width: 2px;
  }
}
.item-type {
  text-align: right;
}
.item-brand {
  text-align: left;
  // color: #000;
}

.item-type,
.item-brand {
  color: #fff;
  margin-left: 5px;
  margin-right: 5px;
  min-width: 210px;
  padding: 10px;
}
</style>
